/**
 * Redirige vers la page /commander-pro si le client est pro
 */

import { useCheckoutStore } from "@/store/checkout";
import { useClientStore } from "@/store/client";

export default defineNuxtRouteMiddleware((route) => {

  const { $pinia } = useNuxtApp();
  const clientStore = useClientStore($pinia);
  const checkoutStore = useCheckoutStore($pinia);

  if (clientStore.isPro) {
    return navigateTo("/commander-pro", { replace: true });
  }

  // gestion du paramètre d'url type_panier dans le tunnel
  if (checkoutStore.typePanier && !route.query.type_panier) {
    // cas d'accès au tunnel via le panier
    return navigateTo({ path: route.path, query: { ...route.query, type_panier: checkoutStore.typePanier } });
  } else if (route.query.type_panier) {
    // cas de refresh/back_navigateur depuis le tunnel
    checkoutStore.setTypePanier(route.query.type_panier);
  } else if (!checkoutStore.typePanier && !route.query.type_panier) {
    // cas d'accès manuel à l'url /commander sans paramètre type_panier
    checkoutStore.setTypePanier("drive");
  }
  return;
})
